// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"d2786972","251":"5f596626","283":"804c1614","304":"ccfc5650","363":"65d84ca5","499":"8c520260","581":"8f0ae139","639":"3ed80bf5","650":"415f8474","859":"70387263","888":"567bdba3","918":"0a378f5f","954":"d6faaace"}[chunkId] + ".chunk.js";
};